import { Component, Input, ViewEncapsulation } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-store-link-after-linking-body",
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: "./store-link-after-linking-body.component.html",
  styleUrls: ["./store-link-after-linking-body.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class StoreLinkAfterLinkingBodyComponent {
  @Input() userName = "there";
  @Input() momentStep = "afterLinkingStore";
  showActions = true;
}
